"use client";

import StyleMyWardrobeSlice from "../../components/Organisms/StyleMyWardrobeSlice";
const StyleMyWardrobe = ({ slice }) => {
    return (
        <section>
            <StyleMyWardrobeSlice data={slice} />
        </section>
    );
};

export default StyleMyWardrobe;
